import { mobifinTheme } from '@/theme/mobifinTheme'

interface MobiFinLogoProps {
  className?: string
  showTagline?: boolean
}

export default function MobiFinLogo({ className = '', showTagline = false }: MobiFinLogoProps) {
  return (
    <div className={`flex flex-col ${className}`}>
      <div className="flex items-baseline">
        <span className="text-3xl font-bold" style={{ color: mobifinTheme.colors.primary.blue }}>
          Mobi
        </span>
        <span className="text-3xl font-bold" style={{ color: mobifinTheme.colors.primary.orange }}>
          Fin
        </span>
        <span className="text-sm ml-1" style={{ color: mobifinTheme.colors.primary.orange }}>
          ®
        </span>
      </div>
      {showTagline && (
        <span className="text-xs text-gray-600 mt-1">
          Tapestry Workflow Builder
        </span>
      )}
    </div>
  )
}